/*
* Pipeline Theme - Force page reload on variant change
*/

(function() {
  
  // Wait for DOM to be ready
  function init() {
    // Find all variant option inputs (radio buttons and selects)
    var variantInputs = document.querySelectorAll('input[name^="options["], select[name^="options["]');
    
    variantInputs.forEach(function(input) {
      input.addEventListener('change', function(e) {
        // Stop the default Alpine.js behavior
        e.stopImmediatePropagation();
        
        // Get the changeVariant call from the @change attribute
        var changeAttr = input.getAttribute('@change') || input.getAttribute('x-on:change');
        
        if (changeAttr && changeAttr.includes('changeVariant')) {
          // Extract the URL from changeVariant('URL', ...)
          var match = changeAttr.match(/changeVariant\s*\(\s*'([^']+)'/);
          if (match && match[1]) {
            var url = match[1];
            // Force page reload with the new variant URL
            window.location.href = url;
          }
        }
      }, true); // Use capture phase to intercept before Alpine
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-run after any section reloads (in case inputs are replaced)
  document.addEventListener('theme:section:load', function() {
    setTimeout(init, 100);
  });
  
})();
